import React from 'react'
import { Container, Image, Row, Col, ButtonGroup, Button } from 'react-bootstrap';
import style from './Home.module.css';
import imgLogo from '../../assets/images/ifh-logo.png';
import { NavLink } from 'react-router-dom';

const Home = () => {
  return (
    <Container className={style.homeContainer} fluid>
      <Container>
        <Row className='d-flex justify-content-center text-center'>
          <Col>
            <Image src={imgLogo}/>
          </Col>
        </Row>
        <Row className='d-flex justify-content-center text-center'>
          <Col className="text-center mt-4" sm={12} md={6}>
            <h3 className={style.homeWelcomeTitle}>¡Te damos la bienvenida al Instituto Filosófico Hermético!</h3>
          </Col>
        </Row>
        <Row className="justify-content-center text-center mt-4">
          <Col className="d-flex justify-content-end mt-2" sm={12} md={4}>
          <NavLink to="/login" className={style.homeBtnContainer}>
            <Button className={`${style.loginBtn} ${style.homeBtns} p-3`}>Ingresar</Button>
          </NavLink>
          </Col>
          <Col className="d-flex justify-content-start mt-2" sm={12} md={4}>
          <NavLink to="/signUp" className={style.homeBtnContainer}>
            <Button className={`${style.registerBtn} ${style.homeBtns} p-3`}>Registrarse</Button>
          </NavLink>
          </Col>
        </Row>
      </Container>
    </Container>
  )

}

export default Home;